import { render, staticRenderFns } from "./CFormComponent.vue?vue&type=template&id=5040ec96&scoped=true&"
import script from "./CFormComponent.vue?vue&type=script&lang=js&"
export * from "./CFormComponent.vue?vue&type=script&lang=js&"
import style0 from "./CFormComponent.vue?vue&type=style&index=0&id=5040ec96&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5040ec96",
  null
  
)

export default component.exports